/**
 * The variant for the AbstractAuthenticationData enum.
 */
export enum AbstractAuthenticationDataVariant {
  V1 = 0,
  DerivableV1 = 1,
}

/**
 * The variant for the AASigningData enum.
 */
export enum AASigningDataVariant {
  V1 = 0,
}
